import { Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

export abstract class isBrowser {
	isBrowser: boolean;

	constructor(@Inject(PLATFORM_ID) private platformId: object) {
		this.isBrowser = isPlatformBrowser(platformId);
	}
}
